export * from './erinnerungen.component';
export * from './erinnerungen.component.module';